// src/pages/CompaniesPage/companyDialog/sections/SectionKategorien.jsx
import React from "react";
import { Alert, Box, CircularProgress, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { normalizeIdArray } from "../utils/companyUtils";

export default function SectionKategorien({
                                              form,
                                              setForm,
                                              categories,
                                              categoriesLoading,
                                              categoriesError,
                                          }) {
    const toggleCategory = (id) => {
        setForm((f) => {
            const ids = new Set(normalizeIdArray(f.category_ids));
            if (ids.has(id)) ids.delete(id);
            else ids.add(id);
            return { ...f, category_ids: Array.from(ids).sort((a, b) => a - b) };
        });
    };

    return (
        <>
            {categoriesError && (
                <Alert severity="error" sx={{ mb: 1 }}>
                    {categoriesError}
                </Alert>
            )}

            {categoriesLoading ? (
                <Box sx={{ py: 2, textAlign: "center" }}>
                    <CircularProgress size={20} />
                </Box>
            ) : categories?.length ? (
                <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                        {normalizeIdArray(form.category_ids).length} von {categories.length} ausgewählt
                    </Typography>

                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr",
                                sm: "repeat(2, minmax(0, 1fr))",
                                md: "repeat(3, minmax(0, 1fr))",
                                lg: "repeat(4, minmax(0, 1fr))",
                            },
                            gap: 0.25,
                            maxHeight: 360,
                            overflowY: "auto",
                            pr: 1,
                            py: 0.5,
                        }}
                    >
                        {categories.map((cat) => {
                        const id = Number(cat.id);
                        const checked = normalizeIdArray(form.category_ids).includes(id);
                        const label = cat.label_de || cat.name;
                        return (
                            <FormControlLabel
                                key={cat.id}
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={checked}
                                        onChange={() => toggleCategory(id)}
                                        sx={{ py: 0.5 }}
                                    />
                                }
                                label={label}
                                sx={{
                                    m: 0,
                                    minWidth: 0,
                                    borderRadius: 1,
                                    px: 0.75,
                                    py: 0.25,
                                    bgcolor: checked ? "rgba(240, 172, 77, 0.10)" : "transparent",
                                    "&:hover": { bgcolor: "action.hover" },
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "0.875rem",
                                        lineHeight: 1.25,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    },
                                }}
                            />
                        );
                        })}
                    </Box>
                </Box>
            ) : (
                <Alert severity="info">Keine Kategorien vorhanden. Lege zuerst Kategorien an.</Alert>
            )}
        </>
    );
}
